<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>设备管理</el-breadcrumb-item>
      <el-breadcrumb-item>动销显示</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane v-loading.fullscreen.lock="fullscreenloading" name="first" label="清单列表">
        <el-row :gutter="20">
          <!-- 组织机构 start -->
          <el-col :span="5">
            <el-tree
            :data="treeData"
            @node-click="handleNodeClick"
            show-checkbox
            node-key="id"
            ref="tree"
            :highlight-current="true"
            :default-expand-all="true"
            :expand-on-click-node="false"
            class="tree1">
            </el-tree>
          </el-col>
          <!-- 组织机构 end -->
          <!-- 机构列表 start -->
          <el-col :span="19">
            <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
              <el-date-picker v-model="keywords.begintime" type="date" value-format="yyyy-MM-dd" placeholder="开始时间" class="mr15"></el-date-picker>
              <el-date-picker v-model="keywords.endtime" type="date" value-format="yyyy-MM-dd" placeholder="结束时间" class="mr15"></el-date-picker>
              <el-form-item label="">
                <el-select v-model="keywords.bomsn" placeholder="请选择" class="select" style="width: 200px;">
                  <el-option
                    v-for="item in bomSnList" :key="item.Value" :label="item.Label" :value="item.Value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="keywords.saletype" placeholder="请选择" class="select" style="width: 200px;">
                  <el-option
                    v-for="item in saleTypeList" :key="item.Value" :label="item.Label" :value="item.Value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="clicksearch">查询</el-button>
                <el-button type="success" @click="clickexcel">导出Excel</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="dataListMix" :row-class-name="tableRowClassName" border stripe @cell->
              <el-table-column prop="Jigouname" label="机构名称"></el-table-column>
              <el-table-column prop="NumYiKaiHu" label="已开户数量" sortable></el-table-column>
              <el-table-column prop="NumWeiKaiHu" label="未开户数量" sortable></el-table-column>
              <el-table-column prop="NumTotal" label="总数量" sortable></el-table-column>
            </el-table>
          </el-col>
          <!-- 机构列表 end -->
        </el-row>

      </el-tab-pane>
      <!-- 清单列表 end -->
    </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyDeviceSaleStatistical',
  data () {
    return {
      fullscreenloading: false,
      activeName: 'first',
      // 左侧机构数据列表
      treeData: [],
      // 机构列表数据
      dataList: [],
      dataListMix: [],
      keywords: {
        begintime: '',
        endtime: '',
        bomsn: '103-0000-0001',
        saletype: '1'
      },
      bomSnList: [],
      saleTypeList: [],
      clickparentid: 1
    }
  },
  mounted () {
    this.apigetjigoutree()

    var that = this
    Vue.prototype.FunListBomsn(function (response) {
      if (response.data.Code === 200) {
        that.bomSnList = response.data.List
        that.saleTypeList = response.data.ListSaleType
      }
    })
  },
  methods: {
    clicksearch () {
      this.apiGetDeviceSaleStatistical()
    },
    clickexcel () {
      this.apiExcelDeviceSaleStatistical()
    },
    handleNodeClick (data) {
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'firstline'
      }
      return ''
    },
    apigetjigoutree: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        companytype: '0'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoutree, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.treeData = []
            response.data.List.filter((item1, i1) => {
              var list2 = []
              item1.List.filter((item2, i2) => {
                var list3 = []
                item2.List.filter((item3, i3) => {
                  var list4 = []
                  item3.List.filter((item4, i4) => {
                    var list5 = []
                    item4.List.filter((item5, i5) => {
                      list5.push({ id: item5.Id, label: item5.Jigouname, children: '' })
                    })
                    if (list5.length == 0) list5 = ''
                    list4.push({ id: item4.Id, label: item4.Jigouname, children: list5 })
                  })
                  if (list4.length == 0) list4 = ''
                  list3.push({ id: item3.Id, label: item3.Jigouname, children: list4 })
                })
                if (list3.length == 0) list3 = ''
                list2.push({ id: item2.Id, label: item2.Jigouname, children: list3 })
              })
              if (list2.length == 0) list2 = ''
              that.treeData.push({ id: item1.Id, label: item1.Jigouname, children: list2 })
            })
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetDeviceSaleStatistical: function () {
      var that = this
      that.fullscreenloading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouids: that.$refs.tree.getCheckedKeys().toString(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetDeviceSaleStatistical, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.paixuData()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.fullscreenloading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.fullscreenloading = false
        })
    },
    apiExcelDeviceSaleStatistical: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouids: that.$refs.tree.getCheckedKeys().toString(),
        begintime: that.keywords.begintime,
        endtime: that.keywords.endtime,
        bomsn: that.keywords.bomsn,
        saletype: that.keywords.saletype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelDeviceSaleStatistical, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            // that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   showCancelButton: true,
            //   type: 'warning'
            // }).then(() => {
            //   that.$router.push({ path: '/FileManagementExcel' })
            // })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    paixuData () {
      var that = this
      that.dataList.sort(function (a, b) {
        var y = a.NumYiKaiHu
        var x = b.NumYiKaiHu
        if (x < y) { return -1 }
        if (x > y) { return 1 }
        return 0
      })
      var NumYiKaiHu = 0
      var NumWeiKaiHu = 0
      var NumTotal = 0
      that.dataList.filter((item1, i1) => {
        NumYiKaiHu += item1.NumYiKaiHu
        NumWeiKaiHu += item1.NumWeiKaiHu
        NumTotal += item1.NumTotal
      })

      that.dataListMix = []
      that.dataListMix.push({
        Jigouname: '合计',
        NumYiKaiHu: NumYiKaiHu,
        NumWeiKaiHu: NumWeiKaiHu,
        NumTotal: NumTotal
      })
      that.dataListMix.push.apply(that.dataListMix, that.dataList)
    }
  }
}
</script>

<style lang="less" scoped>
.tree1{
  height: 685px;
  overflow-y: scroll;
}
.tree2{
  height: 350px;
  overflow-y: scroll;
}
.tree1::-webkit-scrollbar,
.tree2::-webkit-scrollbar {
    display: none;
}
.select1{
    width: 113px;
    margin-right: 15px;
}
.select2{
    width: 100%;
}
.treedialog {
  height: 350px;
  overflow-y: scroll;
}
.treedialog::-webkit-scrollbar {
  display: none;
}
</style>
